$(function(){

  const windowW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  
  ScrollTrigger.matchMedia({
    "(min-width: 992px)": function(){

      const widthBox = document.querySelector('.box3 .container');
      const scrollboxW = document.querySelector('.scrollbox ul').scrollWidth;
      const scrollboxWItem3 = document.querySelector('.scrollbox .item3').scrollWidth;
      const width =  widthBox.scrollWidth;
      let leftWidth = (windowW - width) / 2;
      let leftToW = scrollboxW-leftWidth-width;
    
      ScrollTrigger.create({
        trigger: '.box4',
        start: 'top top',
        end:'+=200% bottom',
        scrub: true,
        pin: true,
        
        animation:
          gsap.timeline()
          .fromTo('.scrollbox',{transform: `translateX(${leftWidth}px)`},{transform: `translateX(-${leftToW}px)`})
      })

    },
    "(max-width: 750px)": function(){

    }
  })

  const box6Video = document.getElementById("box6-video");

  let videoUrl = ''
  if(windowW < 1920){
    videoUrl = 'https://cdn.shopify.com/videos/c/o/v/5a34853a3e1440cc8573073bf12b75ee.mp4'
  }else{
    videoUrl = 'https://cdn.shopify.com/videos/c/o/v/5a34853a3e1440cc8573073bf12b75ee.mp4'
  }

  ScrollTrigger.create({
    trigger: '#box6-video',
    start: 'top 60%',
    end:'bottom bottom',
    scrub: true,
    onEnter(){
      box6Video.src = videoUrl
      box6Video.play()
    }
  })

})
